import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { useSelector } from "react-redux"
import { Card, CardActions, CardContent, Paper, Typography } from "@mui/material"
import TranslatedText, { useTranslation } from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function UserRequests() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [partners, setPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
   
    const [incomingData, setIncomingData] = useState([]);
    const [outgoingData, setOutgoingData] = useState([]);

    // INCOMING pagination
    const [incomingStartRow, setIncomingStartRow] = useState(0);
    const [incomingPageRows, setIncomingPageRows] = useState(100);
    const [incomingMaxRows, setIncomingMaxRows] = useState(100);
    const [incomingTotalRows, setIncomingTotalRows] = useState(0);
    const [incomingLoading, setIncomingLoading] = useState(false);

    // OUTGOING pagination
    const [outgoingStartRow, setOutgoingStartRow] = useState(0);
    const [outgoingPageRows, setOutgoingPageRows] = useState(100);
    const [outgoingMaxRows, setOutgoingMaxRows] = useState(100);
    const [outgoingTotalRows, setOutgoingTotalRows] = useState(0);
    const [outgoingLoading, setOutgoingLoading] = useState(false);

    useEffect(() => {
        dispatch(setCurrentPage(`User Requests`))
    }, [dispatch]);

    const { showSnackbar } = useSnackbar();

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

     const [filterParams, setFilterParams] = useState({
        status: accesslevel === '5' ? 'not completed' : '',
        priority: '',
        partnerbank: '',
        subject: '',
        body: ''
    })


    let partnermode = false


    const priorities: any = {
        '': useTranslation('Any'),
        'low': useTranslation('Low'),
        'medium': useTranslation('Medium'),
        'high': useTranslation('High'),
    }

    const statuses: any = {
        '': useTranslation('Any'),
        'not completed': useTranslation('Not completed'),
        'completed': useTranslation('Completed'),
        'planned': useTranslation('Accepted, system improvement in the next version of the robot'),
        'closed': useTranslation('Closed'),
    }


    const truncateString = (s: string, w: number) => s.length > w ? s.slice(0, w) + "..." : s;

    //Get word group
    async function fetchIncoming(params: object = {}, startRowParam = incomingStartRow, maxRowsParam = incomingMaxRows) {
        setIncomingLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/usermessages`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow: startRowParam, maxRows: maxRowsParam, calculatetotalcount: true, direction: "incoming" }
            })
            if (response.data !== null && typeof response.data === 'object') {
                setIncomingTotalRows(+response.data[0].totalcount)
                setIncomingData(response.data.slice(1))
            } else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            setIncomingLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") logOut(dispatch)
            else if (error.code === "ERR_NETWORK") showSnackbar('ERROR NETWORK', 'error')
            setIncomingLoading(false)
        }
    }

    // Получение всех исходящих без пагинации
    async function fetchOutgoing(params: object = {}, startRowParam = outgoingStartRow, maxRowsParam = outgoingMaxRows) {
        setOutgoingLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/usermessages`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow: startRowParam, maxRows: maxRowsParam, calculatetotalcount: true, direction: "outgoing" }
            })
            if (response.data !== null && typeof response.data === 'object') {
                setOutgoingTotalRows(+response.data[0].totalcount)
                setOutgoingData(response.data.slice(1))
            } else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            setOutgoingLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") logOut(dispatch)
            else if (error.code === "ERR_NETWORK") showSnackbar('ERROR NETWORK', 'error')
            setOutgoingLoading(false)
        }
    }

    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }




    //on load - fetch data
    useEffect(() => {
        fetchIncoming(filterParams, incomingStartRow, incomingMaxRows)
        fetchOutgoing(filterParams, outgoingStartRow, outgoingMaxRows)
        accesslevel === "5" && getPartners()
    }, [])

    // При изменении фильтров сбрасываем пагинацию и перезапрашиваем данные
    useEffect(() => {
        setIncomingMaxRows(incomingPageRows)
        setIncomingStartRow(0)
        setOutgoingMaxRows(outgoingPageRows)
        setOutgoingStartRow(0)
        // fetchIncoming(filterParams, 0, incomingPageRows)
        // fetchOutgoing(filterParams, 0, outgoingPageRows)
    }, [filterParams])

    // INCOMING pagination handlers
    const incomingTotalPages = Math.ceil(incomingTotalRows / incomingPageRows);
    const incomingCurrentPage = Math.ceil(incomingMaxRows / incomingPageRows);

    function handleIncomingBack() {
        if ((incomingStartRow - incomingPageRows) < 0) {
            setIncomingStartRow(0)
            setIncomingMaxRows(incomingPageRows)
            fetchIncoming(filterParams, 0, incomingPageRows)
        }
        else {
            setIncomingStartRow((prev) => {
                const newStart = prev - incomingPageRows;
                fetchIncoming(filterParams, newStart, incomingMaxRows - incomingPageRows)
                return newStart;
            })
            setIncomingMaxRows((prev) => prev - incomingPageRows)
        }
    }
    function handleIncomingNext() {
        setIncomingStartRow((prev) => {
            const newStart = prev + incomingPageRows;
            fetchIncoming(filterParams, newStart, incomingMaxRows + incomingPageRows)
            return newStart;
        })
        setIncomingMaxRows((prev) => prev + incomingPageRows)
    }
    function handleIncomingEnd() {
        const newStart = incomingTotalRows % incomingPageRows === 0 ? incomingTotalRows - incomingPageRows : incomingTotalRows - (incomingTotalRows % incomingPageRows);
        const newMax = incomingTotalRows % incomingPageRows === 0 ? incomingTotalRows : incomingTotalRows - (incomingTotalRows % incomingPageRows) + incomingPageRows;
        setIncomingStartRow(newStart)
        setIncomingMaxRows(newMax)
        fetchIncoming(filterParams, newStart, newMax)
    }
    function handleIncomingStart() {
        setIncomingStartRow(0)
        setIncomingMaxRows(incomingPageRows)
        fetchIncoming(filterParams, 0, incomingPageRows)
    }

    // OUTGOING pagination handlers
    const outgoingTotalPages = Math.ceil(outgoingTotalRows / outgoingPageRows);
    const outgoingCurrentPage = Math.ceil(outgoingMaxRows / outgoingPageRows);

    function handleOutgoingBack() {
        if ((outgoingStartRow - outgoingPageRows) < 0) {
            setOutgoingStartRow(0)
            setOutgoingMaxRows(outgoingPageRows)
            fetchOutgoing(filterParams, 0, outgoingPageRows)
        }
        else {
            setOutgoingStartRow((prev) => {
                const newStart = prev - outgoingPageRows;
                fetchOutgoing(filterParams, newStart, outgoingMaxRows - outgoingPageRows)
                return newStart;
            })
            setOutgoingMaxRows((prev) => prev - outgoingPageRows)
        }
    }
    function handleOutgoingNext() {
        setOutgoingStartRow((prev) => {
            const newStart = prev + outgoingPageRows;
            fetchOutgoing(filterParams, newStart, outgoingMaxRows + outgoingPageRows)
            return newStart;
        })
        setOutgoingMaxRows((prev) => prev + outgoingPageRows)
    }
    function handleOutgoingEnd() {
        const newStart = outgoingTotalRows % outgoingPageRows === 0 ? outgoingTotalRows - outgoingPageRows : outgoingTotalRows - (outgoingTotalRows % outgoingPageRows);
        const newMax = outgoingTotalRows % outgoingPageRows === 0 ? outgoingTotalRows : outgoingTotalRows - (outgoingTotalRows % outgoingPageRows) + outgoingPageRows;
        setOutgoingStartRow(newStart)
        setOutgoingMaxRows(newMax)
        fetchOutgoing(filterParams, newStart, newMax)
    }
    function handleOutgoingStart() {
        setOutgoingStartRow(0)
        setOutgoingMaxRows(outgoingPageRows)
        fetchOutgoing(filterParams, 0, outgoingPageRows)
    }

    //exclusion of unnecessary table renderers
    // const memoizedTable = useMemo(() => <Table rows={tableData} page={'wordgroup'} />, [tableData]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100%", justifyContent: "space-between" }}>
                {accesslevel != 5 && <Link to='/userrequest' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={'New request'} /></Button>
                </Link>}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: 'wrap', width: '100%', justifyContent: 'center' }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Status'} /></InputLabel>
                        <Select renderValue={(selected) => {
                            return statuses[selected]
                        }} sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.status} onChange={(e) => setFilterParams({ ...filterParams, status: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Status'} />} >
                            <MenuItem value={''}><TranslatedText text={'Any'} /></MenuItem>
                            <MenuItem value={'not completed'}><TranslatedText text={'Not completed'} /></MenuItem>
                            <MenuItem value={'completed'}><TranslatedText text={'Completed'} /></MenuItem>
                            <MenuItem value={'planned'}><TranslatedText text={'Accepted, system improvement in the next version of the robot'} /></MenuItem>
                            <MenuItem value={'closed'}><TranslatedText text={'Сlosed'} /></MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Priority'} /></InputLabel>
                        <Select renderValue={(selected) => {
                            return priorities[selected]
                        }} sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.priority} onChange={(e) => setFilterParams({ ...filterParams, priority: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Priority'} />} >
                            <MenuItem value={''}><TranslatedText text={'Any'} /></MenuItem>
                            <MenuItem value={'low'}><TranslatedText text={'Low'} /></MenuItem>
                            <MenuItem value={'medium'}><TranslatedText text={'Medium'} /></MenuItem>
                            <MenuItem value={'high'}><TranslatedText text={'High'} /></MenuItem>
                        </Select>
                    </FormControl>
                    {accesslevel == 5 &&
                        <FormControl>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                            <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, partnerbank: e.target.value })} value={filterParams.partnerbank} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                <MenuItem value={''}><TranslatedText text={'All'} /></MenuItem>
                                {
                                    partners.map((el: any) => (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>}
                    <TextField value={filterParams.subject} onChange={(e) => setFilterParams({ ...filterParams, subject: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Topic contains'} />} />
                    <TextField value={filterParams.body} onChange={(e) => setFilterParams({ ...filterParams, body: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Text contains'} />} />


                    <Button onClick={() => { fetchIncoming(filterParams); fetchOutgoing(filterParams); }} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {/* {memoizedTable} */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 2 }}>
                        {/* Incoming */}
                        {!partnermode && <Paper elevation={3} sx={{ width: '49%', minWidth: 500, height: '80vh', padding: 2, display: 'flex', flexDirection: 'column', }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, width: '100%' }}>
                                <Typography variant="h5"><TranslatedText text={'Incoming'} /> <span style={{ opacity: 0.5 }}>({incomingTotalRows})</span></Typography>
                                {accesslevel != 5 &&<Typography sx={{ opacity: 0.5 }}>*<TranslatedText text={'Responses to requests from operators'} /></Typography>}
                            </Box>
                            <Box sx={{ overflow: 'auto', p: 2 }}>
                                {incomingLoading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                                    incomingData.length === 0
                                        ? <Typography sx={{ opacity: 0.6, textAlign: 'center', mt: 4 }}><TranslatedText text={'No requests'} /></Typography>
                                        : incomingData.map((el: any) => {
                                            return (
                                                <Card key={el.id} variant="outlined" sx={{ padding: 1, borderRight: `5px solid ${(el.priority === 'high' && el.status !== 'planned') ? 'red' : (el.priority === 'medium' && el.status !== 'planned') ? 'orange' : (el.priority === 'low' && el.status !== 'planned') ? 'green' : 'blue'}`, mb: 2 }}>
                                                    <CardContent sx={{ width: '100%', flexWrap: 'wrap' }}>
                                                        <Box sx={{ width: '100%', mb: 1 }}>
                                                            <Typography variant="h5" component="div">
                                                                {el.partnerbankcode}
                                                            </Typography>
                                                            <Typography color="text.secondary">
                                                                {el.subject}
                                                            </Typography>
                                                            <Link style={{ textDecoration: 'none', color: '#1976d2' }} to={`/user?id=${el.user}&type=profile`}>
                                                                <Typography>{el.username}</Typography>
                                                            </Link>

                                                        </Box>
                                                        <Typography variant="body2" sx={{ textOverflow: 'ellipsis', overflow: "hidden", width: '100%' }}>
                                                            {truncateString(el.body ? el.body : '', 150)}
                                                        </Typography>
                                                    </CardContent>
                                                    <CardActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                                        <Link to={`/userrequest?id=${el.id}&type=edit`}>
                                                            <Button variant="outlined" size="small">
                                                                <TranslatedText text={'Reply'} />
                                                            </Button>
                                                        </Link>
                                                        {/* <Button variant='outlined' size="small"><TranslatedText text={'read and answer'} /></Button> */}
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            <TranslatedText text={'Priority'} />: <TranslatedText text={el.priority ? el.priority : ''} />
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            <TranslatedText text={'Status'} />: <TranslatedText text={el.status ? el.status : ''} />
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            {accesslevel == 5 ? el.updatedbyuser : el.updatedbycg}
                                                        </Typography>
                                                    </CardActions>
                                                </Card>
                                            )
                                        })}
                            </Box>
                            {/* Пагинация для incoming */}
                            <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto', justifyContent: 'space-between' }}>
                                <Box sx={{ mt: 2, gap: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Box>
                                        <Button disabled={incomingStartRow === 0} onClick={handleIncomingStart} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                        <Button disabled={incomingStartRow === 0} onClick={handleIncomingBack} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                    </Box>
                                    <Box>
                                        <Button disabled={incomingMaxRows >= incomingTotalRows} onClick={handleIncomingNext} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                        <Button disabled={incomingMaxRows >= incomingTotalRows || incomingData.length < incomingPageRows} onClick={handleIncomingEnd} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                                    </Box>
                                </Box>
                                <Typography sx={{ pt: 2 }}><TranslatedText text={'Rows on page:'} /> {incomingPageRows}</Typography>
                                <Typography sx={{ pt: 2 }}>
                                    <TranslatedText text={'Page:'} /> {incomingCurrentPage} / {incomingTotalPages}
                                </Typography>
                                <Typography sx={{ pt: 2 }}><TranslatedText text={'Total rows:'} /> {incomingTotalRows}</Typography>
                            </Box>
                        </Paper>}

                        {/* Outgoing */}
                        <Paper elevation={3} sx={{ width: partnermode ? '70%' : "49%", minWidth: 500, height: '80vh', padding: 2, display: 'flex', flexDirection: 'column', }}>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, width: '100%' }}>
                                <Typography variant="h5"> <TranslatedText text={'Outgoing'} /> <span style={{ opacity: 0.5 }}>({outgoingTotalRows})</span></Typography>
                               {accesslevel != 5 && <Typography sx={{ opacity: 0.5 }}>*<TranslatedText text={'Outgoing requests that have not yet been responded to'} /></Typography>}
                            </Box>
                            <Box sx={{ overflow: 'auto', p: 2 }}>
                                {outgoingLoading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                                    outgoingData.length === 0
                                        ? <Typography sx={{ opacity: 0.6, textAlign: 'center', mt: 4 }}><TranslatedText text={'No requests'} /></Typography>
                                        : outgoingData.map((el: any) => {
                                            return (
                                                <Card key={el.id} variant="outlined" sx={{ padding: 1, borderRight: `5px solid ${(el.priority === 'high' && el.status !== 'planned') ? 'red' : (el.priority === 'medium' && el.status !== 'planned') ? 'orange' : (el.priority === 'low' && el.status !== 'planned') ? 'green' : 'blue'}`, mb: 2 }}>
                                                    <CardContent sx={{ width: '100%', flexWrap: 'wrap' }}>
                                                        <Box sx={{ width: '100%', mb: 1 }}>
                                                            <Typography variant="h5" component="div">
                                                                {el.partnerbankcode}
                                                            </Typography>
                                                            <Typography color="text.secondary">
                                                                {el.subject}
                                                            </Typography>
                                                            <Link style={{ textDecoration: 'none', color: '#1976d2' }} to={`/user?id=${el.user}&type=profile`}>
                                                                <Typography>{el.username}</Typography>
                                                            </Link>

                                                        </Box>
                                                        <Typography variant="body2" sx={{ textOverflow: 'ellipsis', overflow: "hidden", width: '100%' }}>
                                                            {truncateString(el.body ? el.body : '', 150)}
                                                        </Typography>
                                                    </CardContent>
                                                    <CardActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                                        <Link to={`/userrequest?id=${el.id}&type=edit`}>
                                                            <Button variant="outlined" size="small">
                                                                <TranslatedText text={'Edit'} />
                                                            </Button>
                                                        </Link>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            <TranslatedText text={'Priority'} />: <TranslatedText text={el.priority ? el.priority : ''} />
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            <TranslatedText text={'Status'} />: <TranslatedText text={el.status ? el.status : ''} />
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                            {accesslevel == 5 ? el.updatedbycg : el.updatedbyuser}
                                                        </Typography>
                                                    </CardActions>
                                                </Card>
                                            )
                                        })}
                            </Box>
                            {/* Пагинация для outgoing */}
                            <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto', justifyContent: 'space-between' }}>
                                <Box sx={{ mt: 2, gap: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Box>
                                        <Button disabled={outgoingStartRow === 0} onClick={handleOutgoingStart} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                        <Button disabled={outgoingStartRow === 0} onClick={handleOutgoingBack} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                    </Box>
                                    <Box>
                                        <Button disabled={outgoingMaxRows >= outgoingTotalRows} onClick={handleOutgoingNext} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                        <Button disabled={outgoingMaxRows >= outgoingTotalRows || outgoingData.length < outgoingPageRows} onClick={handleOutgoingEnd} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                                    </Box>
                                </Box>
                                <Typography sx={{ pt: 2 }}><TranslatedText text={'Rows on page:'} /> {outgoingPageRows}</Typography>
                                <Typography sx={{ pt: 2 }}>
                                    <TranslatedText text={'Page:'} /> {outgoingCurrentPage} / {outgoingTotalPages}
                                </Typography>
                                <Typography sx={{ pt: 2 }}><TranslatedText text={'Total rows:'} /> {outgoingTotalRows}</Typography>
                            </Box>
                        </Paper>
                    </Box>
                </>}
        </Box>
    )
}